export default __webpack_public_path__ + "static/char-s-sp01-ko-0d99830cb939ad64921ad40c32c975e2.webp";